// @flow

import React from 'react'
import type { Node } from 'react'
import styled from 'styled-components'
import { NavigationLink } from './navigation-link'

import { myTheme } from '../../styles'

const { space, fontSize } = myTheme

const ListItem = styled.li`
  font-size: ${fontSize.six};

  &:not(:last-child) {
    margin-right: ${space.two};
  }
`

type Props = {
  to: string,
  children: Node,
}

const NavigationItem = ({ to, children }: Props) => (
  <ListItem>
    <NavigationLink to={to}>{children}</NavigationLink>
  </ListItem>
)

export default NavigationItem



// WEBPACK FOOTER //
// ./src/components/navigation/navigation-item.js